<template lang="">
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" width="53.66" height="53.66" viewBox="0 0 53.66 53.66">
  <g id="Schedule_Test_Drive" data-name="Schedule Test Drive" transform="translate(-719.813 -307.996)">
    <circle id="Ellipse_1081" data-name="Ellipse 1081" cx="26.33" cy="26.33" r="26.33" transform="translate(720.313 308.496)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    <g id="Group_8587" data-name="Group 8587" transform="translate(731.598 319.548)">
      <circle id="Ellipse_971" data-name="Ellipse 971" cx="14.822" cy="14.822" r="14.822" transform="translate(0 0)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <path id="Path_69794" data-name="Path 69794" d="M79.164,71.228c2.043,0,2.043,1.76,4.087,1.76H87.8c-.517-5.176-5.56-9.239-11.705-9.239s-11.188,4.062-11.705,9.238h4.554c2.043,0,2.043-1.76,4.087-1.76Z" transform="translate(-61.277 -60.671)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_909" data-name="Line 909" x2="1.76" transform="translate(13.943 15.811)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <path id="Path_69795" data-name="Path 69795" d="M274.26,281.251a10.131,10.131,0,0,1-8.01,7.324s0-3.805,0-3.805a3.517,3.517,0,0,1,3.519-3.52Z" transform="translate(-248.043 -262.163)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <path id="Path_69796" data-name="Path 69796" d="M77.693,288.576a10.131,10.131,0,0,1-8.01-7.325h4.491a3.517,3.517,0,0,1,3.519,3.52S77.693,288.575,77.693,288.576Z" transform="translate(-66.256 -262.163)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    </g>
  </g>
</svg>

  </div>
</template>
<script>
export default {
  props: {
    themeColor: {
      type: String,
      default: '#B3B3B3'
    },
    height: {
      type: String,
      default: '53.66px'
    },
    width: {
      type: String,
      default: '53.66px'
    }
  }
}
</script>
<style lang="">

</style>
